// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HeroSection.module.css */

.HeroSection_heroContainer__5uZAl {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    color: white;
  }
  
  .HeroSection_heroBackground__JfGLp {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
  }
  
  .HeroSection_heroImage__8hnZG {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .HeroSection_heroGradientOverlay__hrZuR {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: 
    linear-gradient(
      to top,
      rgba(26, 26, 26, 0.6) 0%,
      rgba(26, 26, 26, 0) 50%
    ),
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.4) 55%,
      rgba(0, 0, 0, 0) 80%,
      #1a1a1a 100%
    );
    z-index: 2;
  }
  
  .HeroSection_heroContent__P9dK0 {
    position: relative;
    z-index: 3;
    padding: 0 5%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    max-width: 600px;
  }
  
  .HeroSection_heroTitle__usmwi {
    font-size: 3rem;
    font-weight: 700;
    margin-bottom: 1rem;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
  }
  
  .HeroSection_heroDescription__wi26c {
    font-size: 1.25rem;
    margin-bottom: 2rem;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  
  .HeroSection_heroButtons__tgATC {
    display: flex;
    gap: 1rem;
  }
  
  .HeroSection_btnPlay__fPn10, .HeroSection_btnMore__V-Ls0 {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.5rem;
    border-radius: 4px;
    font-weight: 600;
    font-size: 1.125rem;
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;
  }
  
  .HeroSection_btnPlay__fPn10 {
    background-color: #dc2626;
    color: white;
  }
  
  .HeroSection_btnPlay__fPn10:hover {
    background-color: #e81616;
  }
  
  .HeroSection_btnMore__V-Ls0 {
    background-color: rgba(109, 109, 110, 0.7);
    color: white;
  }
  
  .HeroSection_btnMore__V-Ls0:hover {
    background-color: rgba(109, 109, 110, 0.5);
  }
  
  .HeroSection_heroControls__Mg42G {
    position: absolute;
    right: 5%;
    bottom: 20%;
    display: flex;
    gap: 1rem;
    z-index: 4;
  }
  
  .HeroSection_controlButton__-pFl- {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.6);
    border: 1px solid rgba(255, 255, 255, 0.7);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  
  .HeroSection_controlButton__-pFl-:hover {
    background-color: rgba(0, 0, 0, 0.8);
    transform: scale(1.1);
  }
  
  .HeroSection_heroIndicators__387VR {
    position: absolute;
    bottom: 5%;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 0.5rem;
    z-index: 4;
  }
  
  .HeroSection_indicator__-THsy {
    width: 12px;
    height: 3px;
    background-color: rgba(255, 255, 255, 0.4);
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  
  .HeroSection_indicatorActive__zvb54 {
    background-color: white;
    width: 24px;
  }
  
  .HeroSection_heroLoading__q--VA {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80vh;
    color: white;
    background-color: #141414;
    font-size: 1.5rem;
  }
  
  /* Media Queries for responsive design */
  @media (max-width: 1024px) {
    .HeroSection_heroTitle__usmwi {
      font-size: 2.5rem;
    }
    
    .HeroSection_heroDescription__wi26c {
      font-size: 1.125rem;
    }
  }
  
  @media (max-width: 768px) {
    .HeroSection_heroContainer__5uZAl {
      height: 70vh;
    }
    
    .HeroSection_heroContent__P9dK0 {
      max-width: 100%;
      text-align: center;
      align-items: center;
      padding: 0 8%;
    }
    
    .HeroSection_heroTitle__usmwi {
      font-size: 2rem;
    }
    
    .HeroSection_heroDescription__wi26c {
      font-size: 1rem;
      -webkit-line-clamp: 2;
    }
    
    .HeroSection_heroButtons__tgATC {
      flex-direction: column;
      width: 100%;
      max-width: 300px;
    }
    
    .HeroSection_btnPlay__fPn10, .HeroSection_btnMore__V-Ls0 {
      width: 100%;
      justify-content: center;
    }
    
    .HeroSection_heroControls__Mg42G {
      right: 50%;
      transform: translateX(50%);
      bottom: 15%;
    }
  }
  
  @media (max-width: 480px) {
    .HeroSection_heroContainer__5uZAl {
      height: 85vh;
    }
    .HeroSection_heroButtons__tgATC{
        position: relative;
        bottom: -10rem;
    }
    
    .HeroSection_heroTitle__usmwi {
      font-size: 18px;
    }
    
    .HeroSection_heroDescription__wi26c {
      font-size: 12px;
    }
    
    .HeroSection_btnPlay__fPn10, .HeroSection_btnMore__V-Ls0 {
      padding: 0.5rem 1rem;
      font-size: 1rem;
    }
    
    .HeroSection_controlButton__-pFl- {
      width: 36px;
      height: 36px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/reading-pages/components/Css/HeroSection.module.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ;;;;;;;;;;;KAWC;IACD,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,2CAA2C;EAC7C;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0CAA0C;IAC1C,YAAY;EACd;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,0CAA0C;IAC1C,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;IACpC,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,WAAW;IACX,0CAA0C;IAC1C,YAAY;IACZ,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA,wCAAwC;EACxC;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,mBAAmB;IACrB;EACF;;EAEA;IACE;MACE,YAAY;IACd;;IAEA;MACE,eAAe;MACf,kBAAkB;MAClB,mBAAmB;MACnB,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,qBAAqB;IACvB;;IAEA;MACE,sBAAsB;MACtB,WAAW;MACX,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,uBAAuB;IACzB;;IAEA;MACE,UAAU;MACV,0BAA0B;MAC1B,WAAW;IACb;EACF;;EAEA;IACE;MACE,YAAY;IACd;IACA;QACI,kBAAkB;QAClB,cAAc;IAClB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,oBAAoB;MACpB,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;EACF","sourcesContent":["/* HeroSection.module.css */\n\n.heroContainer {\n    position: relative;\n    width: 100%;\n    height: 100vh;\n    overflow: hidden;\n    color: white;\n  }\n  \n  .heroBackground {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    z-index: 1;\n  }\n  \n  .heroImage {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  \n  .heroGradientOverlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: \n    linear-gradient(\n      to top,\n      rgba(26, 26, 26, 0.6) 0%,\n      rgba(26, 26, 26, 0) 50%\n    ),\n    linear-gradient(\n      to bottom,\n      rgba(0, 0, 0, 0.4) 55%,\n      rgba(0, 0, 0, 0) 80%,\n      #1a1a1a 100%\n    );\n    z-index: 2;\n  }\n  \n  .heroContent {\n    position: relative;\n    z-index: 3;\n    padding: 0 5%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n    max-width: 600px;\n  }\n  \n  .heroTitle {\n    font-size: 3rem;\n    font-weight: 700;\n    margin-bottom: 1rem;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);\n  }\n  \n  .heroDescription {\n    font-size: 1.25rem;\n    margin-bottom: 2rem;\n    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n  }\n  \n  .heroButtons {\n    display: flex;\n    gap: 1rem;\n  }\n  \n  .btnPlay, .btnMore {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1.5rem;\n    border-radius: 4px;\n    font-weight: 600;\n    font-size: 1.125rem;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border: none;\n  }\n  \n  .btnPlay {\n    background-color: #dc2626;\n    color: white;\n  }\n  \n  .btnPlay:hover {\n    background-color: #e81616;\n  }\n  \n  .btnMore {\n    background-color: rgba(109, 109, 110, 0.7);\n    color: white;\n  }\n  \n  .btnMore:hover {\n    background-color: rgba(109, 109, 110, 0.5);\n  }\n  \n  .heroControls {\n    position: absolute;\n    right: 5%;\n    bottom: 20%;\n    display: flex;\n    gap: 1rem;\n    z-index: 4;\n  }\n  \n  .controlButton {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background-color: rgba(0, 0, 0, 0.6);\n    border: 1px solid rgba(255, 255, 255, 0.7);\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n  }\n  \n  .controlButton:hover {\n    background-color: rgba(0, 0, 0, 0.8);\n    transform: scale(1.1);\n  }\n  \n  .heroIndicators {\n    position: absolute;\n    bottom: 5%;\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    gap: 0.5rem;\n    z-index: 4;\n  }\n  \n  .indicator {\n    width: 12px;\n    height: 3px;\n    background-color: rgba(255, 255, 255, 0.4);\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n  }\n  \n  .indicatorActive {\n    background-color: white;\n    width: 24px;\n  }\n  \n  .heroLoading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 80vh;\n    color: white;\n    background-color: #141414;\n    font-size: 1.5rem;\n  }\n  \n  /* Media Queries for responsive design */\n  @media (max-width: 1024px) {\n    .heroTitle {\n      font-size: 2.5rem;\n    }\n    \n    .heroDescription {\n      font-size: 1.125rem;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .heroContainer {\n      height: 70vh;\n    }\n    \n    .heroContent {\n      max-width: 100%;\n      text-align: center;\n      align-items: center;\n      padding: 0 8%;\n    }\n    \n    .heroTitle {\n      font-size: 2rem;\n    }\n    \n    .heroDescription {\n      font-size: 1rem;\n      -webkit-line-clamp: 2;\n    }\n    \n    .heroButtons {\n      flex-direction: column;\n      width: 100%;\n      max-width: 300px;\n    }\n    \n    .btnPlay, .btnMore {\n      width: 100%;\n      justify-content: center;\n    }\n    \n    .heroControls {\n      right: 50%;\n      transform: translateX(50%);\n      bottom: 15%;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .heroContainer {\n      height: 85vh;\n    }\n    .heroButtons{\n        position: relative;\n        bottom: -10rem;\n    }\n    \n    .heroTitle {\n      font-size: 18px;\n    }\n    \n    .heroDescription {\n      font-size: 12px;\n    }\n    \n    .btnPlay, .btnMore {\n      padding: 0.5rem 1rem;\n      font-size: 1rem;\n    }\n    \n    .controlButton {\n      width: 36px;\n      height: 36px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heroContainer": `HeroSection_heroContainer__5uZAl`,
	"heroBackground": `HeroSection_heroBackground__JfGLp`,
	"heroImage": `HeroSection_heroImage__8hnZG`,
	"heroGradientOverlay": `HeroSection_heroGradientOverlay__hrZuR`,
	"heroContent": `HeroSection_heroContent__P9dK0`,
	"heroTitle": `HeroSection_heroTitle__usmwi`,
	"heroDescription": `HeroSection_heroDescription__wi26c`,
	"heroButtons": `HeroSection_heroButtons__tgATC`,
	"btnPlay": `HeroSection_btnPlay__fPn10`,
	"btnMore": `HeroSection_btnMore__V-Ls0`,
	"heroControls": `HeroSection_heroControls__Mg42G`,
	"controlButton": `HeroSection_controlButton__-pFl-`,
	"heroIndicators": `HeroSection_heroIndicators__387VR`,
	"indicator": `HeroSection_indicator__-THsy`,
	"indicatorActive": `HeroSection_indicatorActive__zvb54`,
	"heroLoading": `HeroSection_heroLoading__q--VA`
};
export default ___CSS_LOADER_EXPORT___;
